import { FormInstance } from 'antd';

import GeneralInformation from './working-conditions-form-components/general-information.component';
import CompanyInformation from './working-conditions-form-components/company-information.component';
import PositionInformation from './working-conditions-form-components/position-information.component';
import WorkingInformation from './working-conditions-form-components/working-information.component';
import CancelInformation from './working-conditions-form-components/cancel-information.component';

import { ConditionMainWrapper } from './working-conditions.styles';
import { StyledWrapper } from '../employee-common.styles';


const WorkingConditions = ({ isEdit, form }: { form: FormInstance; isEdit?: boolean }) => (
  <ConditionMainWrapper>
    <StyledWrapper>
      <GeneralInformation isEdit={isEdit} form={form} />
      <CompanyInformation />
      <PositionInformation />
      <WorkingInformation />
      <CancelInformation />
    </StyledWrapper>
  </ConditionMainWrapper>
);

export default WorkingConditions;
